import api from "./base";

/**
 * Fetches the SMS credit balance for the current teacher.
 * @returns {Promise<{success: boolean, freeCredits: number, purchasedCredits: number, totalCredits: number}>}
 */
export async function fetchSmsBalance() {
    const res = await api.get("/teacher/sms/balance");
    return res.data;
}

/**
 * Purchases an SMS credit package.
 * @param {number} packageId - The package ID to purchase
 * @param {number} paymentMethodId - The payment method to charge
 * @returns {Promise<{success: boolean, creditsAdded: number, freeCredits: number, purchasedCredits: number, totalCredits: number, error?: string}>}
 */
export async function purchaseSmsCredits(packageId, paymentMethodId) {
    const res = await api.post("/teacher/sms/purchase", {
        packageId,
        paymentMethodId,
    });
    return res.data;
}
